import { Formik } from "formik";
import React, { useState } from "react";
import toast from "react-hot-toast";
import * as yup from "yup";
import { ResetPasswordByPcAdmin } from "../../../../../../api";
import TextInput from "../../../../../components/form/text-input";
import Modal from "../../../../../components/modal";
import Button from "../../../../../components/new-button";
import layoutStyles from "../../../../../styles/layout.module.scss";

const schema = yup.object({
  password: yup
    .string()
    .trim()
    .required("Password is required")
    .min(14, "Password must be at least 14 characters.")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter.")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter.")
    .matches(/[0-9]/, "Password must contain at least one number.")
    .matches(/[\-!@#$%^&*()_+\[\]{}|;:,.<>?]/, "Password must contain at least one special character."),
  password_confirmation: yup
    .string()
    .trim()
    .required("Confirm Password is required")
    .min(14, "Password must be at least 14 characters.")
    .oneOf(
      [yup.ref("password"), null],
      "The Password confirmation does not match.",
    ),
});

const ResetPasswordModal = ({ open, onClose, memberId }) => {
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    password: "",
    password_confirmation: "",
  });

  const handleResetPasswordFormSubmit = (values, { setSubmitting }) => {
    setSubmitting(true);
    toast.loading("Resetting password...", { duration: 10000 });

    ResetPasswordByPcAdmin({
      id: memberId,
      password: values.password,
      password_confirmation: values.password_confirmation,
    })
      .then((res) => {
        if (res.status === 200) {
          toast.dismiss();
          toast.success("Password reset successfully", { duration: 5000 });
          onClose();
        } else {
          toast.dismiss();
          toast.error("There was an error resetting the password", { duration: 5000 });
          console.error(res.message ?? res);
        }
      })
      .catch((error) => {
        toast.dismiss();
        toast.error("There was an error resetting the password", { duration: 5000 });
        console.error(error);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <>
      <Modal isOpen={open} onClose={onClose} header="Reset password" size="sm">
        <Formik
          enableReinitialize
          validationSchema={schema}
          onSubmit={handleResetPasswordFormSubmit}
          initialValues={formData}
          initialErrors={errors}
          validateOnBlur={false}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            touched,
            errors,
            setFieldValue,
            isSubmitting,
          }) => (
            <form autoComplete="off" onSubmit={handleSubmit}>
              <div className={`${layoutStyles.grid} ${layoutStyles.gap2}`}>
                <div
                  className={`${layoutStyles.grid} ${layoutStyles.gridCols1} ${layoutStyles.gap2}`}
                >
                  <TextInput
                    label="Password"
                    id="password"
                    name="password"
                    type="password"
                    defaultValue={values.password}
                    onChange={handleChange}
                    touched={touched.password}
                    errored={errors.password}
                    error={errors["password"]}
                  />
                  <TextInput
                    label="Confirm password"
                    id="password_confirmation"
                    name="password_confirmation"
                    type="password"
                    defaultValue={values.password_confirmation}
                    onChange={handleChange}
                    touched={touched.password_confirmation}
                    errored={errors.password_confirmation}
                    error={errors["password_confirmation"]}
                  />
                </div>
                <div className={`${layoutStyles.grid} ${layoutStyles.gap2}`}>
                  <div
                    className={`${layoutStyles.flex} ${layoutStyles.flexEnd} ${layoutStyles.gap1}`}
                  >
                    <Button type="button" variant="ghost" onClick={onClose}>
                      Cancel
                    </Button>
                    <Button type="submit" disabled={isSubmitting}>
                      Update
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default ResetPasswordModal;
